import { Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Course } from "../../const/types";

type Props = {
  data: Course;
};

export default function CourseDetailModalLink({ data }: Props) {
  return (
    <>
      <Text
        color={"p.300"}
        cursor={"pointer"}
        as={Link}
        to={`/allcourses/${data.id}`}
      >
        {data.nama_course}
      </Text>
    </>
  );
}
